export const product = {
  getItem: 'productEndpoint/getItem',
  getItemV2: 'productEndpoint/v2/getItem',
  getFiltersItems: 'filtersEndpoint/getFiltersItems',
  getItemAvailable: 'productEndpoint/getItemAvailableStoresCity2',
  getDiscounts: 'talon-one/customer-session/v2/getDiscounts',
};
